module.exports = __webpack_public_path__ + "img/human.07c88563.svg";